export const HELP_CENTER_URL = 'https://help.letshighlight.com/help';

/** A published help center article, by its slug: `helpArticleUrl('project-timelines')`. */
export const helpArticleUrl = (slug: string) => `${HELP_CENTER_URL}/${slug}`;
